import { useCurrentSite } from '@hotjar/site';
import { useCurrentUser } from '@hotjar/user';

interface OwnerRouteProps {
  children: JSX.Element;
  fallbackUI: JSX.Element;
}

/**
 * A component that checks if a user is the owner of the account before rendering the route.
 *
 * <Route path="/<some_path>" element={
 *   <OwnerRoute>
 *     <MyComponent />
 *   </OwnerRoute>
 * } />
 */
export const OwnerOrAdminRoute = ({
  children,
  fallbackUI,
}: OwnerRouteProps): JSX.Element | null => {
  const { data: currentSite } = useCurrentSite();
  const { data: currentUser } = useCurrentUser();

  const isOwner = currentUser ? currentSite?.account?.adminIds?.includes(currentUser.id) : false;
  const isAdmin = currentUser?.isAdminOfOneOrganization;

  if (isOwner === true || isAdmin === true) {
    return children;
  }

  return fallbackUI;
};
